import React, { useEffect } from "react";
import { Col, Container, Row, FormGroup} from "react-bootstrap";
import { Input, Form } from 'antd';
import { AuthHeader, ImageElement } from "../../components";
import { Link, useNavigate } from "react-router-dom";

function Login() {
    const navigate = useNavigate();
    useEffect(() => {
        let navbar = document.querySelector(".header");
        let navbarHeight = navbar?.clientHeight;
        let authPage = document.querySelector(".authPage_inner");
        if(authPage){
        authPage.style.minHeight = `${window.innerHeight - navbarHeight}px`;
        }
    });
    return (
        <>
            <AuthHeader />
            <main className="authPage">
                <div className="authPage_inner d-flex flex-column justify-content-center align-items-center">
                    <Container>
                        <Row className="g-0 align-items-center">
                            <Col xxl="6" lg="5" className="d-none d-lg-block">
                                <div className="authPage_left">
                                    <ImageElement source="auth-img.png" className="img-fluid"/>
                                </div>
                            </Col>
                            <Col xxl="6" lg="7">
                                <div className="authPage_right w-100 ms-lg-auto">
                                    <div className="authPage_top w-100 mx-auto">
                                        <h1 className="authPage_top_title text-center">Welcome to <br/> Good Guys Home Services!</h1>
                                        <p className="mb-0 text-center">Service on your way!</p>
                                        <div className="authPage_top_login">
                                            <Form>          
                                                <FormGroup className="form-group">
                                                    <label className="ant-label w-100">Mobile Number / Email</label>
                                                    <Input size="large" placeholder="Mobile Number / Email"  />
                                                </FormGroup>
                                                <FormGroup className="form-group">
                                                    <label className="ant-label w-100">Password</label>
                                                    <Input.Password size="large" placeholder="Password" iconRender={visible => (visible ? <div><em className="gg-eye-on"/></div> : <div><em className="gg-eye-off"/></div>)}/>
                                                </FormGroup>
                                                <div className="text-end">
                                                    <Link to="/forgot-password" className="forgotxt d-inline-block">Forgot Password?</Link>
                                                </div>
                                                <Link to='/dashboard'  size="lg" className="w-100 btn btn-primary btn-lg" type="button">Login</Link>
                                                <div className="text-center authPage_top_txt">
                                                Don't have an account? <Link to="/signup" className="forgotxt font-md mb-0">Book Online</Link>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                    <div className="authPage_bottom text-center">
                                        Signing up allows you to schedule appointments, cancel appointments, view past receipts, pay online (contactless payments), view/approve quotes, track your technician on the way to your home, take advantage of any specials, and more.
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>
        </>
    );
  }
  
  export default Login;